import React from "react";
import { Instagram, Mail, Phone } from "lucide-react";
import { motion } from "framer-motion";
import { BeaconsIcon } from "./BeaconsIcon";

export const Footer = ({ data }) => {
  const contact = data?.contact || {};
  const year = new Date().getFullYear();

  const socials = [
    { icon: Instagram, href: contact.instagram, label: "Instagram" },
    { icon: BeaconsIcon, href: contact.facebook, label: "Beacons" },
    { icon: Mail, href: `mailto:${contact.email}`, label: "Email" },
    { icon: Phone, href: `tel:${contact.phone}`, label: "Phone" },
  ];

  return (
    <footer className="relative overflow-hidden bg-void border-t border-line" data-testid="footer">
      {/* Compact brand block */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="text-center"
        >
          <span className="font-display text-4xl md:text-5xl tracking-tight text-gold">
            Mixing Dreams Ltd
          </span>
          <p className="mt-3 text-smoke text-sm md:text-base italic font-display">
            Crafting Experiences, One Pour at a Time
          </p>
        </motion.div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-14 pb-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 border-t border-line pt-10">
          <p className="text-smoke text-xs order-2 md:order-1 max-w-2xl leading-relaxed">
            &copy; {year} Mixing Dreams Ltd. All rights reserved. All content on this website, including text, images and branding, is the exclusive property of Mixing Dreams Ltd and may not be reproduced, distributed or used without prior written permission.
          </p>

          <div className="flex items-center gap-3 order-1 md:order-2">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="flex h-11 w-11 items-center justify-center rounded-full border border-line text-smoke transition-all duration-300 hover:border-gold hover:text-gold hover:-translate-y-0.5"
              >
                <s.icon size={18} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
